import { Card, Col, Row, Select, Table, Tag } from "antd";
import { useSearchParams } from "react-router-dom";

const FishStockUpdate = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const columns = [
    {
      title: "Nama",
      dataIndex: "product_name",
      key: "product_name",
      width: 150,
      ellipsis: true,
      render: (v) => v || "-",
    },
    {
      title: "Stock",
      dataIndex: "status",
      key: "status",
      width: 100,
      align: "center",
      render: (status) =>
        status === "Out of Stock" ? (
          <Tag color="red">{status}</Tag>
        ) : (
          <Tag color="green">{status}</Tag>
        ),
    },
    {
      title: "Persentase Ketersediaan",
      dataIndex: "stock_percentage",
      key: "stock_percentage",
      width: 200,
      align: "center",
      render: (value, record) =>
        value && record?.status === "Available" ? `${value}%` : "-",
    },
  ];

  const onStockFilterChange = (value) => {
    setSearchParams({ stock: value });
  };

  const updateSearchParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <Card style={{ padding: 4 }}>
      <div
        style={{
          display: "flex",
          gap: 8,
          justifyItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h3>Produk Stock Update</h3>
      </div>
      <Table
        rowKey={(dataSource) => dataSource.id}
        columns={columns}
        dataSource={props.data}
        loading={props.loading}
        tableLayout="fixed"
        pagination={{
          pageSize: 5,
          showSizeChanger: false,
          showLessItems: true,
        }}
        style={{ minWidth: "100%" }}
        scroll={{ x: 300 }}
      />
    </Card>
  );
};

export default FishStockUpdate;
